import React, { useEffect, useState } from "react";
import CustomPaper from "../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../CustomComponents/CustomCardContent/CustomCardContent";
import { useStyles } from "../../assets/jss/AdminCard";
import CustomBox from "../CustomComponents/CustomBox/CustomBox";
import clsx from "clsx";
import { NavLink } from "react-router-dom";

export default function AdminCard(props) {
  const classes = useStyles();
  const [cardData, setCardData] = useState(null);
  useEffect(() => {
    if (props.data) {
      setCardData(props.data);
    }
  }, [props.data]);
  return (
    <CustomPaper
      square
      elevation={0}
      className={clsx(classes.cardContentWrapper)}
    >
      {cardData && (
        <NavLink
          className={clsx(
            classes.cardLink,
            !cardData.isEnabled && classes.cardDisabled
          )}
          to={cardData.link}>

          {/* <CustomLink
          className={clsx(
            classes.cardLink,
            !cardData.isEnabled && classes.cardDisabled
          )}
          href={cardData.link}
        > */}
          <CustomCard
            elevation={0}
            className={clsx(classes.cardContentWrapper)}
          >
            <CustomCardContent className={classes.cardContent}>
              <CustomBox className={classes.iconWrapper}>
                <img
                  width={70}
                  src={cardData.icon}
                  alt="Icon"
                  className={classes.icon}
                />
              </CustomBox>
              <CustomBox className={classes.title}>{cardData.title}</CustomBox>
              <CustomBox className={classes.description}>
                {cardData.description}
              </CustomBox>
            </CustomCardContent>
          </CustomCard>
        </NavLink>
      )}
    </CustomPaper>
  );
}
